export const getEnv = () => {
  const env = process.env.NODE_ENV;
  if (!env) {
    throw new Error("NODE_ENV is not set");
  }
  return env;
}

export const getTLD = (): string => {
  const cookieDomain = process.env.COOKIE_DOMAIN as string;
  if (!cookieDomain) {
    throw new Error("COOKIE_DOMAIN is not set");
  }
  return cookieDomain;
};

export const getAccountsApiHost = (): string => {
  const accountApiHost = process.env.ACCOUNTS_API as string;
  if (!accountApiHost) {
    throw new Error("ACCOUNTS_API is not set");
  }
  return accountApiHost;
};

export const getAccountApiUrl = (path: string): string => {
  return `${getAccountsApiHost()}${path}`
}

export const getAccountsWebUrl = (path: string): string => {
  const accountsWebHost = process.env.ACCOUNTS_WEB;
  return `${accountsWebHost}${path}`;
}

export const getWakeletUrl = (path?: string): string => {
  const wakeletWebUrl = process.env.WAKELET_WEB as string;
  if (!wakeletWebUrl) {
    throw new Error("WAKELET_WEB is not set");
  }
  return `${wakeletWebUrl}${path || ""}`;
};

export const getReturnUrl = (origin?: string, path?: string): string => {
  return origin ? `${origin}${path || ""}` : getWakeletUrl(path);
}

export const isDev = () => getEnv() === "development";
export const isProd = () => getEnv() === "production"
export const isStaging = () => getEnv() === "staging";
